/**
 * This helper function extracts the validation message from object
 * in case if there is no message undefined will be returned
 * @param validationResult - universal validation result object
 * @returns - validation messsage or undefined
 */
export function getFirstErrorMessage(validationResult) {
    var _a;
    return (_a = validationResult.messages) === null || _a === void 0 ? void 0 : _a[0];
}
/**
 *  Formats final message
 *  @param isValid - is validation result valid
 *  @param errorMessage - if validation faliled there will be message about failure
 *  @returns universal validation formated object
 */
export function formatValidation(isValid, errorMessage) {
    return {
        isValid,
        message: errorMessage
    };
}
